import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import "../../../StyleSheet/MainComponent/ExitFlow/Nodue.scss";
import {
  SetExitNoDueEditActions,
  SetTheExitRetrieveActions,
} from "../../../Redux/Slice";
import Select from "react-select";
import html2pdf from "html2pdf.js";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import jsPDF from "jspdf";
import $ from "jquery";
import html2canvas from 'html2canvas';
import { useReactToPrint } from 'react-to-print';



const Nodue = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const divRef = useRef(null);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initailState = {
    name: "",
    location: "",
    date_of_relieving: "",
    official_email: "",
    kt: "",
    back_up: "",
    clearance: "",
    salary_advance: "",
    other_advance: "",
    petty_cash: "",
    settle_expenses: "",
    it_doc: "",
    happy_account: "",
    laptop: "",
    card_accessories: "",
    email_id: "",
    sap_login: "",
    login_id: "",
    id_access_card: " ",
    business_card: "",
    draw_key: "",
    headset: "",
    sim: "",
    stationary_items: "",
    charger_cable: "",
    medical_claim: "",
    exit_interview: "",
    resign_mail: "",
    notice_period: "",
    relevant: "",
    company_property: "",
    other_handover: "",
    approved_date: "",
    reason_for_decline: "",
  };
  const [Datas, setDatas] = useState(initailState);
  const [formDirty, setFormDirty] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [defualtVal, setDefualtVal] = useState(initailState);
  const formSubmitResponse = useSelector(
    (state) => state.ExitNodueEditCall.ExitNoDueEdit
  );
  // const noDueFormData = useSelector((state) => (state.ExitRetrieveCall.ExitDataRetrieve) )
  // console.log(Datas, "Datas");
  // const handlePrint = () => {
  //   const content = divRef.current.innerHTML;
  //   const printWindow = window.open("", "_blank");
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>Print</title>
  //       </head>
  //       <body>${content}</body>
  //     </html>
  //   `);
  //   printWindow.document.close();
  //   printWindow.print();
  // };

  const Options = [
    {
      id: 1,
      value: "yes",
      lable: "yes",
    },
    {
      id: 2,
      value: "no",
      lable: "No",
    },
    {
      id: 3,
      value: "",
      lable: "Nil",
    },
  ];

  const LanguageChange = (e) => {
    console.log(e.target.value, "values in app");
    setFormDirty(true);
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value == "" ? null: e.target.value,
      };
    });
  };

  const handleSubmitChanges = () => {
    console.log(Datas, "asdfaskdflkjasldf");
    // if (state.ExitRetrieveCall.ExitDataRetrieve.id !== undefined) {
    const payload = {
      id: state.ExitRetrieveCall.ExitDataRetrieve.id,
      data: Datas,
    };
    dispatch(SetExitNoDueEditActions(payload));
    setFormDirty(false);

    // }
  };
  useEffect(() => {
    const payload = {
      EditId: state.ClientBranchIDs.Exit_No_dueData.id,
    };
    dispatch(SetTheExitRetrieveActions(payload));
    setFormDirty(false);
  }, [formSubmitResponse]);

  useEffect(() => {
    const payload = {
      EditId: state.ClientBranchIDs.Exit_No_dueData.id,
    };
    dispatch(SetTheExitRetrieveActions(payload));
  }, []);
  useEffect(() => {
    if (state.ClientBranchIDs.Exit_No_dueData.id != undefined) {
      setDatas({
        ...Datas,
        laptop: state.ExitRetrieveCall.ExitDataRetrieve.laptop,
        kt: state.ExitRetrieveCall.ExitDataRetrieve.kt,
        date_of_relieving:
          state.ExitRetrieveCall.ExitDataRetrieve.date_of_relieving,
        official_email: state.ExitRetrieveCall.ExitDataRetrieve.official_email,
        back_up: state.ExitRetrieveCall.ExitDataRetrieve.back_up,
        clearance: state.ExitRetrieveCall.ExitDataRetrieve.clearance,
        salary_advance: state.ExitRetrieveCall.ExitDataRetrieve.salary_advance,
        other_advance: state.ExitRetrieveCall.ExitDataRetrieve.other_advance,
        petty_cash: state.ExitRetrieveCall.ExitDataRetrieve.petty_cash,
        settle_expenses:
          state.ExitRetrieveCall.ExitDataRetrieve.settle_expenses,
        it_doc: state.ExitRetrieveCall.ExitDataRetrieve.it_doc,
        happy_account: state.ExitRetrieveCall.ExitDataRetrieve.happy_account,
        card_accessories:
          state.ExitRetrieveCall.ExitDataRetrieve.card_accessories,
        email_id: state.ExitRetrieveCall.ExitDataRetrieve.email_id,
        headset:state.ExitRetrieveCall.ExitDataRetrieve.headset,

        sap_login: state.ExitRetrieveCall.ExitDataRetrieve.sap_login,
        login_id: state.ExitRetrieveCall.ExitDataRetrieve.login_id,
        id_access_card: state.ExitRetrieveCall.ExitDataRetrieve.id_access_card,
        business_card: state.ExitRetrieveCall.ExitDataRetrieve.business_card,
        draw_key: state.ExitRetrieveCall.ExitDataRetrieve.draw_key,
        sim: state.ExitRetrieveCall.ExitDataRetrieve.sim,
        stationary_items:
          state.ExitRetrieveCall.ExitDataRetrieve.stationary_items,
        charger_cable: state.ExitRetrieveCall.ExitDataRetrieve.charger_cable,
        medical_claim: state.ExitRetrieveCall.ExitDataRetrieve.medical_claim,
        exit_interview: state.ExitRetrieveCall.ExitDataRetrieve.exit_interview,
        resign_mail: state.ExitRetrieveCall.ExitDataRetrieve.resign_mail,
        notice_period: state.ExitRetrieveCall.ExitDataRetrieve.notice_period,
        relevant: state.ExitRetrieveCall.ExitDataRetrieve.relevant,
        company_property:
          state.ExitRetrieveCall.ExitDataRetrieve.company_property,
        other_handover: state.ExitRetrieveCall.ExitDataRetrieve.other_handover,
        approved_date: state.ExitRetrieveCall.ExitDataRetrieve.approved_date,
        reason_for_decline:
          state.ExitRetrieveCall.ExitDataRetrieve.reason_for_decline,
      });
    }
  }, [state.ExitRetrieveCall.ExitDataRetrieve, state.ClientBranchIDs.Exit_No_dueData]);

  // const handlePrint = () => {
  //   // setPrinting(true);
  //   const element = document.getElementById("printableDiv");
  //   html2pdf().from(element).save();
  //   // setPrinting(false);
  // };
 

  // const handlePrint = () => {
 

    // const element = document.getElementsByClassName("InnerDueForm")[0]; // Get the first element
   


  //   if (element) {
  //     // Save the original content of the body
  //     const originalContent = document.body.innerHTML;
      
  //     const originalStyles = document.body.style.cssText;

  //     const allElements = document.body.children;
  //     for (let i = 0; i < allElements.length; i++) {
  //         if (allElements[i] !== element) {
  //             allElements[i].style.visibility = 'hidden';
  //         }
  //     }
      
  //     element.style.visibility = 'visible';
      
  //     // Call window.print() to print the content
  //     window.print();
      
  //     document.body.innerHTML = originalContent;
  //     document.body.style.cssText = originalStyles;
  // }



    //Wait until PDF is ready to print    

    // html2canvas(element).then((canvas) => {
    //     const imgData = canvas.toDataURL('image/png');
    //     const pdf = new jsPDF();
    //     const imgWidth = 190; // Set width for PDF
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //     let heightLeft = imgHeight;

    //     let position = 0;

    //     // Add the image to the PDF
    //     pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //     heightLeft -= pdf.internal.pageSize.height;

    //     // If the content is taller than one page, add more pages
    //     while (heightLeft >= 0) {
    //         position = heightLeft - imgHeight;
    //         pdf.addPage();
    //         pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
    //         heightLeft -= pdf.internal.pageSize.height;
    //     }

    //     // Save the PDF
    //     pdf.save('nodueform.pdf');
    // });

    
    // if (element) {
    //   // Save the original styles to restore them after printing
    //   const originalStyles = element.style.cssText;
  
    //   // Hide all other elements on the page except the target element
    //   const allElements = document.body.children;
    //   for (let i = 0; i < allElements.length; i++) {
    //     if (allElements[i] !== element) {
    //       allElements[i].style.visibility = 'hidden';  // Hide other elements
    //     }
    //   }
  
    //   // Center the target element on the screen
    //   // element.style.position = "fixed";
    //   // element.style.top = "10%";        // Position at the top of the viewport
    //   // element.style.left = "10%";       // Align to the left of the viewport
    //   // element.style.margin = "0";     // Remove any margins
    //   // element.style.visibility = "visible"; // Ensure the target element is visible
    //   element.style.position = "fixed";
    // element.style.top = "3%";
    // element.style.left = "50%";
    // element.style.transform = "translateX(-50%)"; // Center horizontally
    // element.style.width = "100%";
    // element.style.maxWidth = "1000px"; // Set a max width for better formatting
    // element.style.margin = "0 auto";
    // element.style.visibility = "visible"; // Ensure the target element is visible


  
    //   // Print the visible element
    //   window.print();
  
    //   // Restore original styles and visibility of all elements after printing
    //   element.style.cssText = originalStyles;
    //   for (let i = 0; i < allElements.length; i++) {
    //     allElements[i].style.visibility = ''; // Reset to original visibility
    //   }
    // }
  
   
    
    
  // };
  // const handlePrint = useReactToPrint({
  //   content: () => divRef.current,
  // });
  const handlePrint = useReactToPrint({
    content: () => divRef.current,
    pageStyle: `
      @media print {
        .NoDUEFORMS_FLEX {
          padding: 160px 0px 0px 0px;
        }
      }
    `,
  });
  




  


  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="row noDue"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
            gap: "12px",
            padding: "20px 30px",
          }}
        >
          <button
          className="btn ButtonCSS"
            onClick={(e) => {
              <div className="row">
                <button
                  onClick={(e) => {
                    navigate("/hrinterview");
                  }}
                   
                >
                  HR interview
                </button>

                <button
                  onClick={(e) => {
                    navigate("/");
                  }}
                  className="btn ButtonCSS"

                >
                  {" "}
                  {/* {formDirty ? "Update Change" : "Print PDF"} */}
                  No Due Form{" "}
                </button>
              </div>;
              navigate("/hrinterview");
            }}
          >
            HR interview
          </button>

          <button
            // onClick={(e) => {
            //   if (formDirty) handleSubmitChanges();
            // }}
            className="btn ButtonCSS"
            onClick={() => {
              formDirty ? handleSubmitChanges() : handlePrint();
            }}
          >
            {" "}
            {formDirty ? "Update Change" : "Print PDF"}
          </button>
        </div>
        <div
            className="row Filters ButtonPrevious"
            style={{
              // padding: "25px 28px",
              padding:"0px 19px 1px 15px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
              marginLeft: "0px",
              marginRight: "0px",
              // top: "-30px",
            }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/exit");
                }}
              >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>

              </button>
            </div>
          </div>


          <div className="coverDiv" style={{width:"90%"}}>

        <div
          id="printableDiv"
          // className={`NoDUEFORMS_FLEX ${printing && "a4Div"}`}
          className="NoDUEFORMS_FLEX"
          ref={divRef}
           style={{ width:"100%"}}
        >
          <div
            className="InnerDueForm"
            style={{ padding: "15px"}}
          >
            <div style={{ margin: "0 30px 0 30px", backgroundColor: "white" }}>
              <div className="row NodueForm">
                {/* -------No--due---Header----- */}
                <div
                  className="col-12 text-center HeaderForm"
                  style={{
                    borderTop: "1px solid lightgrey",
                    borderRight: "1px solid lightgrey",
                    borderLeft: "1px solid lightgrey",
                  }}
                >
                  <h3>NO DUE FORM</h3>
                </div>
                {/* -------No--due--Column-Header--and--Input Fields-- 1- */}
                <div className="col columns flexLeft">
                  <span>Name of Employee </span>
                </div>
                <div className="col-sm-4 columns flexLeft">
                  {/* -----input----Field---- */}
                  {/* <input className="InputFieldDue" /> */}
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.first_name
                    }
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.last_name
                    }
                  </p>
                </div>
                <div className="col columns">
                  <span> Employee Code </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* <input className="Inpustate.ExitRetrieveCall.ExitDataRetrievetFieldDue" name = "" value={}/> */}
                  <p>{state.ExitRetrieveCall.ExitDataRetrieve?.user_uid}</p>
                </div>
              </div>

              {/* -------22------------------------------------- */}

              <div className="row SecondRow">
                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                <div className="col columns Destination">
                  <span>Designation </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* -----input----Field---- */}
                  {/* <input className="InputFieldDue" /> */}
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.user_role?.role
                    }
                  </p>
                </div>
                <div className="col columns Destination">
                  <span> Location </span>
                </div>
                <div className="col-sm-4 columns">
                  <p>{state.ExitRetrieveCall.ExitDataRetrieve?.location}</p>
                  {/* <input className="InputFieldDue" /> */}
                </div>
              </div>
              {/* -------33------------------------------------- */}
              <div className="row ThirdRrow">
                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                <div className="col columns ">
                  <span>Department </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* -----input----Field---- */}
                  {/* <input className="InputFieldDue" /> */}
                  <p>{state.ExitRetrieveCall.ExitDataRetrieve?.department}</p>
                </div>
                <div className="col columns ">
                  <span> Date of Joining </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* <input className="InputFieldDue" /> */}
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.joining_date
                    }
                  </p>
                </div>
              </div>
              {/* -------44------------------------------------- */}

              <div className="row FouthRow">
                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                <div className="col columns ">
                  <span>Official Email id </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* -----input----Field---- */}
                  <input
                    className="InputFieldDue"
                    readOnly
                    value={Datas.date_of_relieving}
                  />
                </div>
                <div className="col columns ">
                  <span> Date of Relieving </span>
                </div>
                <div className="col-sm-4 columns">
                  <input
                    className="InputFieldDue"
                    readOnly
                    value={Datas.date_of_relieving}
                  />
                </div>
              </div>
              {/* -------55------------------------------------- */}
              <div className="row SecondRow">
                {/* -------No--due--Column-Header--and--Input Fields---2- */}
                <div className="col columns Destination">
                  <span>Personal Contact Number </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* -----input----Field---- */}
                  {/* <input className="InputFieldDue" /> */}
                  <p>
                    {
                      state.ExitRetrieveCall.ExitDataRetrieve?.user_id
                        ?.phone_number
                    }
                  </p>
                </div>
                <div className="col columns Destination">
                  <span> Personal Email Id </span>
                </div>
                <div className="col-sm-4 columns">
                  {/* <input className="InputFieldDue" /> */}
                  <p>
                    {state.ExitRetrieveCall.ExitDataRetrieve?.user_id?.email}
                  </p>
                </div>
              </div>

              {/* ..........................DEPARTMENT Details--------------------------- */}

              <div className="row DepartmentDetails Headers ">
                <div className="col columns">
                  <span>DEPARTMENT </span>
                </div>
                <div className="col-sm-4 columns">
                  <span>CHECKLIST</span>
                </div>
                <div className="col columns">
                  <span> REMARKS </span>
                </div>
                <div className="col-sm-4 columns">
                  <span>SIGNATURE</span>
                </div>
              </div>

              {/* -------------Inner---Departments--------------------------------- */}
              {/* .......Check---List............................ */}
              {/* ------1------------------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>
                    Dept Head/ Reporting Manager{" "}
                  </span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Knowledge Transfer</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Back up</span>
                    </div>
                    <div className="col-12 ">
                      <span>
                        Clearance for short payments/deductions/outstanding
                        ifany
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      {/* <select
                      style={{
                        width: "100%",
                        border: "0px ",
                        background: "none",
                      }}
                      onChange={LanguageChange}
                      id="selectbox1"
                      name="kt"
                      selected={Datas.kt}
                      value={Datas.kt === "yes" ? "Yes" : "No"}
                      // value="No"
                    >
                      {Options.map((option) => (
                        <option
                          className="Options"
                          key={option.id}
                          /// value={Datas.kt}
                          value={option.value}
                        >
                          {option.lable}
                        </option>
                      ))}
                    </select> */}
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="kt"
                        selected={Datas.kt}
                        value={Datas.kt}
                        // value="No"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            /// value={Datas.kt}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                      {/* <Select
                      className="Selects"
                      styles={customStyles}
                      onChange={(e) => {
                        setFieldErrors((prev) => {
                          return {
                            ...prev,
                            plant: "",
                          };
                        });
                        setPlantSelected([{ value: e.value, label: e.label }]);
                        setData({
                          ...data,
                          plant: e.value,
                        });
                        setProjectSelected([]);
                      }}
                      name="plant"
                      id="plant"
                      options={plantNameFeeder?.map(({ id, plant }) => ({
                        value: id,
                        label: plant,
                      }))}
                      value={plantSelected}
                    /> */}
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="back_up"
                        selected={Datas.back_up}
                        value={Datas.back_up}
                        // value="No"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            /// value={Datas.kt}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="clearance"
                        selected={Datas.clearance}
                        value={Datas.clearance}
                        // value="No"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            /// value={Datas.kt}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* -------22------------------------------------- */}

              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Payroll </span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Salary Advance</span>
                    </div>
                    <div className="col-12 ">
                      <span>Any other advance</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="salary_advance"
                        value={Datas.salary_advance}
                        selected={Datas.salary_advance}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                            selected={Datas.clearance}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 ">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="other_advance"
                        value={Datas.other_advance}
                        selected={Datas.other_advance}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* -------33------------------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Finance</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Petty cash advances</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Settlement of expenses</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Submission of IT Documents</span>
                    </div>
                    <div className="col-12">
                      <span>Happy Account Closure</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="petty_cash"
                        value={Datas.petty_cash}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.settle_expenses}
                        name="settle_expenses"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="it_doc"
                        value={Datas.it_doc}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="happy_account"
                        // value={Datas.happy_account}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            // value={option.value}
                            // value={Datas.happy_account}
                            selected={"No"}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* -------44------------------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>IT</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Laptop</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Data card & Accessories</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>SAP Login Id's</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Email Id</span>
                    </div>
                    <div className="col-12 ">
                      <span> Login Id's</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="laptop"
                        value={Datas.laptop}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="card_accessories"
                        value={Datas.card_accessories}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="sap_login"
                        value={Datas.sap_login}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="email_id"
                        value={Datas.email_id}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 ">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="login_id"
                        value={Datas.login_id}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>
              {/* -------55------------------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Admin</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>ID Card & Access Card</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Draw Keys</span>
                    </div>
                    <div className="col-12">
                      <span>Business Card</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.id_access_card}
                        name="id_access_card"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="draw_key"
                        value={Datas.draw_key}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="business_card"
                        value={Datas.business_card}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* -------55------------------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Purchase</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12">
                      <span>Blackberry / Phone handset</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Sim Card</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Stationary Items</span>
                    </div>
                    <div className="col-12">
                      <span>Charger & Datacable</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="headset"
                        value={Datas.headset}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="sim"
                        value={Datas.sim}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="stationary_items"
                        value={Datas.stationary_items}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-12">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="charger_cable"
                        value={Datas.charger_cable}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* ---------------------6----------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Mediclaim </span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 ">
                      <span style={{ padding: " 10px 2px" }}>Mediclaim</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                          height: "44px",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="medical_claim"
                        value={Datas.medical_claim}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* ---------------------7----------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>HR</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Exit Interview</span>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <span>Resignation Mail / Copy</span>
                    </div>
                    <div className="col-12" style={{ padding: "3px" }}>
                      <span>Notice Period served</span>
                    </div>
                  </div>
                </div>
                <div className="col columns borderBottomClass">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.exit_interview}
                        name="exit_interview"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* <div className="row InnerDoubleInputFields"> */}
                    <div className="col-12 borderBottomClass">
                      {/* <input className="InputFieldDue" /> */}
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.resign_mail}
                        name="resign_mail"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 ">
                      {/* <input className="InputFieldDue" /> */}
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.notice_period}
                        name="notice_period"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* </div> */}

                    {/* <div className="col-12" style={{ padding: "3px" }}>
                    <input className="InputFieldDue" />
                  </div> */}
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* ------------------8------------------------- */}
              <div className="row DepartmentDetails ">
                <div className="col columns InnerDepHeader">
                  <span style={{ paddingLeft: "2px" }}>Operations</span>
                </div>
                <div className="col-sm-4 columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <span>Relevant Correspondence</span>
                    </div>
                    <div
                      className="col-12 borderBottomClass"
                      style={{ padding: "13px 2px " }}
                    >
                      <span>Uniform / shoes or any othercompany property</span>
                    </div>
                    <div className="col-12" style={{ padding: "5px" }}>
                      <span>Any other handover</span>
                    </div>
                  </div>
                </div>
                <div className="col columns">
                  <div className="row InnerHeaderOfChecklist">
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="relevant"
                        value={Datas.relevant}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 borderBottomClass">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                          padding: "16px 0px",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        name="company_property"
                        value={Datas.company_property}
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-12 ">
                      <select
                        style={{
                          width: "100%",
                          border: "0px ",
                          background: "none",
                          padding: "6.5px 0px",
                        }}
                        onChange={LanguageChange}
                        id="selectbox1"
                        value={Datas.other_handover}
                        name="other_handover"
                      >
                        {Options.map((option) => (
                          <option
                            className="Options"
                            key={option.id}
                            value={option.value}
                          >
                            {option.lable}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* .......SIGNATURE............................ */}
                <div className="col-sm-4 columns">
                  <span></span>
                </div>
              </div>

              {/* ---------Signature of the employee------- Signature of the HOD----- */}
              <div className="row SignatureOFNODUE">
                <div className="col-12">
                  <div className="row InnerHeaderOfsigns">
                    <div className="col-6">
                      <span>Signature of the employee</span>
                    </div>

                    <div className="col-6" style={{ textAlign: "right" }}>
                      <span>Signature of the HOD</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default Nodue;